module.exports = __webpack_public_path__ + "static/media/verify-email.22c6161e.png";